export default __webpack_public_path__ + "static/media/DNo.23-0.bdf6f902.jpg";